import { render, staticRenderFns } from "./priceListAdminHis.vue?vue&type=template&id=1110e654&scoped=true"
import script from "./priceListAdminHis.vue?vue&type=script&lang=js"
export * from "./priceListAdminHis.vue?vue&type=script&lang=js"
import style0 from "./priceListAdminHis.vue?vue&type=style&index=0&id=1110e654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1110e654",
  null
  
)

export default component.exports